export const GB_TO_MB_CONVERSION_RATE = 1024;
